(function () {
    function initAboutAnimation() {
        var container = document.querySelector('[data-about-svg-animation]');
        if (!container || typeof window.gsap === 'undefined') return;

        var svgs = Array.prototype.slice.call(
            container.querySelectorAll('.about__line')
        );
        if (!svgs.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.gsap.set(svgs, {
                clipPath: 'inset(0 0% 0 0)'
            });
            return;
        }

        window.gsap.set(svgs, {
            clipPath: 'inset(0 100% 0 0)'
        });

        function playAnimation() {
            var timeline = window.gsap.timeline();
            var durations = [4, 4.3, 4.6];

            svgs.forEach(function (svg, index) {
                timeline.to(svg, {
                    clipPath: 'inset(0 0% 0 0)',
                    duration: durations[index] || 6,
                    ease: 'none'
                }, 0);
            });
        }

        if (!('IntersectionObserver' in window)) {
            playAnimation();
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                playAnimation();
                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.2,
            rootMargin: '0px 0px -10% 0px'
        });

        observer.observe(container);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAboutAnimation);
    } else {
        initAboutAnimation();
    }
})();
